<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px', fullScreenBackdrop: true }" [template]="customLoadingTemplate"></ngx-loading>
<ng-template #customLoadingTemplate></ng-template>

<div class="app-content content">
	<div class="content-wrapper">
		<div class="content-header row mb-1"></div>
		<div class="content-detached">
			<div class="content-body">
				<div *ngIf="!emisorId" class="alert alert-warning">
					No hay empresa seleccionada para configurar integraciones.
				</div>

				<div class="row" *ngIf="emisorId">
					<div class="col-12 mb-4">
						<div class="card card-custom integraciones-card">
							<div class="card-header">
								<div class="alert alert-info alert-developer">
									<div class="d-flex flex-wrap justify-content-between gap-2">
										<div>
											<h6 class="alert-heading mb-1">¿Quieres probar integraciones con SimpleFactura Developer?</h6>
											<p class="mb-2">SimpleFactura Developer es un entorno de pruebas para desarrolladores que permite generar tokens de prueba y simular integraciones sin afectar tu cuenta real.</p>
											
										</div>
										<div class="d-flex align-items-start token-actions btn-developer mt-2">
											<a href="https://developers.simplefactura.cl" target="_blank" rel="noopener" class="btn btn-sm btn-outline-primary">Visitar SimpleFactura Developer</a>
										</div>
									</div>
								</div>
								<div>
									<h4 class="card-title mb-0">Integraciones</h4>
									<div class="integraciones-subtitle">Administra tokens para conectar sistemas externos. Cada token dura 1 año y se muestra una sola vez.</div>
								</div>
								<div class="card-toolbar">
									<button class="btn btn-outline-primary btn-sm" (click)="refreshTokens()" [disabled]="loading">Actualizar</button>
								</div>
							</div>
							<div class="card-body">
								<div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
									<h5 class="mb-0">Tokens de integracion</h5>
									<button type="button" class="btn btn-primary btn-sm" (click)="openCreateTokenModal()" *ngIf="permissions.getPermission('86-10').asignado" [disabled]="loading">Generar token</button>
								</div>
								<div *ngIf="oneTimeToken?.token" class="alert alert-warning integraciones-alert">
									<div class="d-flex flex-wrap justify-content-between gap-2">
										<div>
											<h6 class="alert-heading mb-1">Token generado</h6>
											<p class="mb-2">Por seguridad el token se muestra una sola vez. Guardalo en un lugar seguro.</p>
											<code class="token-code">{{ oneTimeToken.token }}</code>
											<div class="small text-muted mt-2 token-meta">Nombre: {{ oneTimeToken.tokenInfo?.nombre || "Sin nombre" }}</div>
										</div>
										<div class="d-flex align-items-start token-actions">
											<button type="button" class="btn btn-sm btn-outline-primary" (click)="copyToken(oneTimeToken.token)">Copiar</button>
											<button type="button" class="btn btn-sm btn-outline-secondary" (click)="dismissToken()">Ocultar</button>
										</div>
									</div>
								</div>

								<div class="table-responsive mt-4">
									<table class="table table-hover align-middle">
										<thead>
											<tr>
												<th>Nombre</th>
												<th>Integracion</th>
												<th>Token</th>
												<th>Creado</th>
												<th>Vencimiento</th>
												<th>Estado</th>
												<th class="text-end">Acciones</th>
											</tr>
										</thead>
										<tbody>
											<tr *ngFor="let token of tokens">
												<td>{{ token.nombre }}</td>
												<td>{{ token.integracion || "API" }}</td>
												<td><code class="token-inline">{{ getMaskedToken(token) }}</code></td>
												<td>{{ token.fechaCreacion ? (token.fechaCreacion | date: "dd/MM/yyyy") : "-" }}</td>
												<td>
													<div>{{ token.fechaExpiracion ? (token.fechaExpiracion | date: "dd/MM/yyyy") : "-" }}</div>
													<small class="text-muted">{{ getRemainingLabel(token) }}</small>
												</td>
												<td>
													<span class="badge" [ngClass]="getStatusClass(token)">{{ getStatusLabel(token) }}</span>
												</td>
												<td>
													<div class="integraciones-actions">
														<a
															class="primary edit mr-1 mrless action-btn"
															ngbTooltip="Generar nuevo token"
															(click)="rotateToken(token)" *ngIf="permissions.getPermission('86-10').asignado"
															[class.disabled]="loading || actionTokenId === token.tokenId || !isTokenActive(token)"
															[attr.aria-disabled]="loading || actionTokenId === token.tokenId || !isTokenActive(token)">
															<div class="icon-circle bg-info text-center align-middle pt-info-button">
																<fa-icon icon="redo" class="fa-lg text-white"></fa-icon>
															</div>
														</a>
														<a
															class="primary edit mr-1 mrless action-btn"
															ngbTooltip="Dar de baja token"
															(click)="revokeToken(token)" *ngIf="permissions.getPermission('86-10').asignado"
															[class.disabled]="loading || actionTokenId === token.tokenId || !isTokenActive(token)"
															[attr.aria-disabled]="loading || actionTokenId === token.tokenId || !isTokenActive(token)">
															<div class="icon-circle bg-danger text-center align-middle pt-info-button">
																<fa-icon icon="trash" class="fa-lg text-white"></fa-icon>
															</div>
														</a>
													</div>
												</td>
											</tr>
											<tr *ngIf="!tokens.length">
												<td colspan="7" class="text-center text-muted">Sin tokens registrados.</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>

					<div class="col-12">
						<div class="row align-items-stretch">
							<div class="col-lg-4 col-xl-3 mb-4">
								<div class="card card-custom integraciones-card integraciones-card--ecommerce h-100">
								<div class="card-header">
									<div>
										<h4 class="card-title mb-0">Integraciones ecommerce</h4>
										<div class="integraciones-subtitle">Conexiones directas en preparacion para tiendas online.</div>
									</div>
								</div>
								<div class="card-body">
										<div class="integraciones-grid integraciones-grid--stacked">
											<div class="integracion-card integracion-card--compact is-disabled">
											<div class="integracion-card__logo">
												<img src="assets/deployAssets/integraciones/shopify.svg" alt="Shopify" />
											</div>
												<div class="integracion-card__content">
													<div class="integracion-card__title">Shopify</div>
													<span class="badge bg-light text-dark">Proximamente</span>
												</div>
											</div>
											<div class="integracion-card integracion-card--compact is-disabled">
											<div class="integracion-card__logo">
												<img src="assets/deployAssets/integraciones/woocommerce.png" alt="WooCommerce" />
											</div>
												<div class="integracion-card__content">
													<div class="integracion-card__title">WooCommerce</div>
													<span class="badge bg-light text-dark">Proximamente</span>
												</div>
											</div>
											<div class="integracion-card integracion-card--compact is-disabled">
											<div class="integracion-card__logo">
												<img src="assets/deployAssets/integraciones/prestashop.svg" alt="PrestaShop" />
											</div>
												<div class="integracion-card__content">
													<div class="integracion-card__title">PrestaShop</div>
													<span class="badge bg-light text-dark">Proximamente</span>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div class="col-lg-8 col-xl-9 mb-4">
								<div class="card card-custom integraciones-card integraciones-card--partners h-100">
									<div class="card-header">
									<div>
											<h4 class="card-title mb-0">Partners recomendados</h4>
											<div class="integraciones-subtitle">Conoce software aliado que complementa tu operacion y visita sus sitios.</div>
									</div>
								</div>
									<div class="card-body">
										<div class="integraciones-grid integraciones-grid--detailed">
											<a class="integracion-card is-link" href="https://www.gestioncervecera.com" target="_blank" rel="noopener">
												<div class="integracion-card__logo">
													<img src="assets/deployAssets/integraciones/icono_gestion_cervecera2020.png" alt="Gestion Cervecera" />
												</div>
												<div class="integracion-card__content">
													<div class="integracion-card__title">Gestion Cervecera</div>
													<p class="integracion-card__desc">Software de gestión en la nube para fábricas y distribuidoras cerveceras: centraliza la administración y el control del negocio, con módulos como trazabilidad y tracking de barriles.</p>
													<span class="integracion-card__cta">Visitar sitio</span>
												</div>
											</a>
											<a class="integracion-card is-link" href="https://www.mysystem.cl" target="_blank" rel="noopener">
												<div class="integracion-card__logo">
													<img src="assets/deployAssets/integraciones/mysystem.png" alt="MySystem" />
												</div>
												<div class="integracion-card__content">
													<div class="integracion-card__title">MySystem</div>
													<p class="integracion-card__desc">Sistema de venta y equipamiento orientado a todo tipo de negocios como Almacén, Minimarket, Supermercado, Carnicería, Botillería, Bar, Café, Fast Food.</p>
													<span class="integracion-card__cta">Visitar sitio</span>
												</div>
											</a>
											<a class="integracion-card is-link" href="https://www.ifarmacias.cl" target="_blank" rel="noopener">
												<div class="integracion-card__logo">
													<img src="assets/deployAssets/integraciones/logo_backline.jpeg" alt="Backline" />
												</div>
												<div class="integracion-card__content">
													<div class="integracion-card__title">Backline</div>
													<p class="integracion-card__desc">Plataforma para farmacias comunales: compras, stock por lote y vencimiento, fraccionamiento, trazabilidad y dispensación.</p>
													<span class="integracion-card__cta">Visitar sitio</span>
												</div>
											</a>
											<a class="integracion-card is-link" href="https://www.cargotek.net" target="_blank" rel="noopener">
												<div class="integracion-card__logo">
													<img src="assets/deployAssets/integraciones/CTS1Negro.png" alt="StockPilot" />
												</div>
												<div class="integracion-card__content">
													<div class="integracion-card__title">CargoTek</div>
													<p class="integracion-card__desc">Soluciones tecnológicas para logística de carga aérea: iCargo permite registrar y controlar cargas desde su origen hasta el destino final, con soporte y servicios complementarios.</p>
													<span class="integracion-card__cta">Visitar sitio</span>
												</div>
											</a>
											<a class="integracion-card is-link" href="https://payku.com" target="_blank" rel="noopener">
												<div class="integracion-card__logo">
													<img src="assets/deployAssets/integraciones/logo_payku.png" alt="TuBodega" />
												</div>
												<div class="integracion-card__content">
													<div class="integracion-card__title">Payku</div>
													<p class="integracion-card__desc">Pasarela de pagos para vender online en Chile: acepta pagos con integración simple, y soporta alternativas como Webpay y MACH según el medio de pago del comercio.</p>
													<span class="integracion-card__cta">Visitar sitio</span>
												</div>
											</a>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<ng-template #createTokenModal let-modal>
	<div class="modal-header">
		<div class="modal-wizard-label">
			<div class="modal-wizard-title">Generar token</div>
			<div class="modal-wizard-desc">Asigna un nombre para identificar esta integracion.</div>
		</div>
		<button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<form (ngSubmit)="crearToken(modal)" autocomplete="off">
			<div class="form-group">
				<label class="form-label">Nombre del token</label>
				<input class="form-control" name="nuevoTokenNombre" [(ngModel)]="nuevoTokenNombre" [disabled]="loading" placeholder="Ej: Integracion ERP" required />
				<small class="text-muted d-block mt-2">El token expira en 1 año. Luego solo veras los ultimos 4 digitos.</small>
			</div>
			<div class="mt-4 d-flex justify-content-end gap-3">
				<button type="button" class="btn btn-outline-secondary mr-3" [disabled]="loading" (click)="modal.dismiss()">Cancelar</button>
				<button type="submit" class="btn btn-primary" [disabled]="loading">Crear token</button>
			</div>
		</form>
	</div>
</ng-template>

